import { useSite } from "../context/SiteContext";
import { Reveal, SectionHeader } from "../components/home/Sections";
import { SectionBody } from "../components/RichText";
import { Dumbbell, Salad, Activity, Scale, Store, Clock } from "lucide-react";

const PILLAR_ICONS = { pillar_sport: Dumbbell, pillar_nutrition: Salad, pillar_suivi: Activity, pillar_balance: Scale };
const PILLAR_KEYS = ["pillar_sport", "pillar_nutrition", "pillar_suivi", "pillar_balance"];

// Disponibilité des services : donnée métier (état réel de l'offre), non éditoriale.
const SERVICES = [
    { name: "Programme sportif & Nutrition", status: "disponible", label: "Disponible" },
    { name: "Suivi corporel & Balance connectée", status: "disponible", label: "Disponible" },
    { name: "Marketplace Cuisinier", status: "disponible", label: "Disponible" },
    { name: "Services Achat liste de courses", status: "disponible", label: "Disponible" },
];

export default function FonctionnalitesPage() {
    const { data } = useSite();
    const hero = data?.sections?.fonctionnalites_hero;
    if (hero && hero.visible === false) return <main className="bg-cream min-h-screen pt-32 pb-24" data-testid="fonctionnalites-page" />;
    return (
        <main className="bg-cream min-h-screen pt-32 pb-24" data-testid="fonctionnalites-page">
            <div className="container-bc">
                <SectionHeader
                    eyebrow={hero?.eyebrow || "Fonctionnalités détaillées"}
                    title={hero?.title || ""}
                    subtitle={hero?.subtitle || ""}
                />
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                    {PILLAR_KEYS.map((key) => {
                        const sec = data?.sections?.[key];
                        if (!sec || sec.visible === false) return null;
                        const Icon = PILLAR_ICONS[key];
                        const bullets = sec.bullets || [];
                        return (
                            <Reveal key={key}>
                                <article className="h-full rounded-3xl bg-white border border-gold/25 p-8 shadow-sm" data-testid={`feature-${key}`}>
                                    <Icon className="text-gold" size={30} />
                                    <h2 className="font-heading font-bold text-forest text-2xl mt-4">{sec.title}</h2>
                                    <SectionBody sec={sec} className="text-pineneedle mt-3 leading-relaxed text-sm" testid={`feature-body-${key}`} />
                                    {bullets.length > 0 && (
                                        <ul className="mt-5 space-y-2">
                                            {bullets.map((pt, i) => (
                                                <li key={i} className="text-sm text-forest flex items-start gap-2">
                                                    <span className="text-gold mt-0.5">✦</span> {pt}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                    {sec.note && (
                                        <p className="mt-5 text-xs text-pineneedle/80 border-t border-gold/20 pt-4 leading-relaxed">{sec.note}</p>
                                    )}
                                </article>
                            </Reveal>
                        );
                    })}
                </div>
                <Reveal className="mt-16">
                    <h2 className="font-heading font-bold text-forest text-2xl mb-6">Disponibilité des services</h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                        {SERVICES.map((s) => (
                            <div key={s.name} className="rounded-2xl border border-gold/25 bg-white p-5 flex items-center gap-3" data-testid={`service-${s.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
                                {s.status === "disponible" ? <Store className="text-gold shrink-0" size={20} /> : <Clock className="text-sage shrink-0" size={20} />}
                                <div>
                                    <p className="font-semibold text-forest text-sm">{s.name}</p>
                                    <p className={`text-xs mt-0.5 ${s.status === "disponible" ? "text-forest" : "text-pineneedle"}`}>
                                        <span className={`inline-block w-2 h-2 rounded-full mr-1.5 ${s.status === "disponible" ? "bg-green-600" : "bg-gold"}`} />
                                        {s.label}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </Reveal>
            </div>
        </main>
    );
}
